import React from "react";
import { humanizeNumber } from "lib/utils/numberFunctions";
import { truncate } from "lib/utils/stringFunctions";
import EventHeader from "../components/EventHeader";
import TicketSelection from "../components/TicketSelection";

class Tickets extends React.Component {
  constructor(props, context) {
    super(props, context);
  }
  renderTicketLevels() {
    const { ticket_levels, handleClick } = this.props;

    return ticket_levels.map((ticket_level) => {
      const description =
        ticket_level.hide_description != true
          ? truncate(ticket_level.description, 150)
          : "";

      return (
        <button
          data-testid="t-Tickets-button"
          key={ticket_level._id.$oid}
          className="event-ticket-level"
          title="ticket-level"
          onClick={handleClick.bind(this, ticket_level)}>
          <span className="event-ticket-level-info">
            <h3 className="event-ticket-level-title">{ticket_level.name}</h3>
            <span className="event-ticket-level_summary">{description}</span>
          </span>
          <span className="event-ticket-level-price">
            <span className="price-amt">
              {ticket_level.amount ? `$${humanizeNumber(ticket_level.amount)}` : "FREE"}
            </span>
          </span>
        </button>
      );
    });
  }

  render() {
    const {
      event,
      event: { no_registration, enforce_capacity, is_ticket_limit_reached },
      handleTransition,
    } = this.props;

    if (no_registration) {
      return <div className="p-lg-t"></div>;
    }

    if (is_ticket_limit_reached) {
      return (
        <div className="row m-lg-t m-lg-b">
          <div className="col-xs-12">
            <div className="row">
              <div className="event-modal-background">
                <div className="event-modal-body">
                  <div className="event-modal-form">{event.name} has sold out!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="row m-md-b">
        <div className="col-md-6">{this.renderTicketLevels()}</div>

        <div className="col-md-6">
          <TicketSelection
            ticket_levels={this.props.ticket_levels}
            selectedTickets={this.props.selected_tickets}
            tickets={this.props.tickets}
            event={this.props.event}
            updateTicketState={this.props.updateTicketState}
            openRegistration={this.props.event.registration_open}
            handleTransition={this.props.handleTransition}
            handleRemoveTicket={this.props.handleRemoveTicket}
          />
        </div>
      </div>
    );
  }
}

// Tickets.propTypes = {
//   ticket_levels:
// }
export default Tickets;
